module.exports = __webpack_public_path__ + "static/img/3s-platform-img2.53a788f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img2.png
// module id = jzMs
// module chunks = 0